import api from '@shared/services/api';

export const regionService = {
    getCountries: async () => {
        const response = await api.get('/countries/list');
        return response.data;
    },

    createCountry: async (countryData) => {
        try {
            const data = {
                ...countryData,
                active: true
            };
            const response = await api.post('/countries', data);
            return response.data;
        } catch (error) {
            console.error('API Error details:', {
                status: error.response?.status,
                data: error.response?.data,
                headers: error.response?.headers
            });
            throw error;
        }
    },

    updateCountry: async (countryCode, countryData) => {
        try {
            const endpoint = `/countries/${countryCode}`;
            
            const response = await api.put(endpoint, {
                ...countryData,
                active: true,
                oldCountryCode: countryCode
            });
            return response.data;
        } catch (error) {
            console.error('Update country error:', error);
            throw error;
        }
    },

    deleteCountry: async (countryCode) => {
        const response = await api.delete(`/countries/${countryCode}`);
        return response.data;
    },

    getCountry: async (countryCode) => {
        const response = await api.get(`/countries/${countryCode}`);
        return response.data;
    },

    getMunicipalities: async (regionId) => {
        try {
            const response = await api.get(`/subregions/${regionId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching municipalities:', error);
            throw error;
        }
    },

    getTowns: async (municipalityId) => {
        try {
            const response = await api.get(`/cities/code/${municipalityId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching towns:', error);
            throw error;
        }
    },

    
    getRegions: async (countryCode) => {
        try {
            const response = await api.get(`/regions/${countryCode}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching regions:', error);
            throw error;
        }
    },


    createRegion: async (regionData) => {
        const response = await api.post('/regions', regionData);
        return response.data;
    },

    updateRegion: async (regionId, regionData) => {
        const response = await api.put(`/regions/${regionId}`, regionData);
        return response.data;
    },

    deleteRegion: async (regionId) => {
        try {
            const response = await api.delete(`/regions/${regionId}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting region:', error);
            throw error;
        }
    },

    createMunicipality: async (municipalityData) => {
        try {
            const response = await api.post('/subregions', {
                code: municipalityData.code || municipalityData.name.toLowerCase().replace(/\s+/g, '_'),
                name: municipalityData.name,
                regionId: municipalityData.regionId,
                countryCode: municipalityData.countryCode
            });
            return response.data;
        } catch (error) {
            console.error('Error creating municipality:', error);
            throw error;
        }
    },

    updateMunicipality: async (municipalityId, municipalityData) => {
        try {
            const response = await api.put(`/subregions/${municipalityId}`, {
                code: municipalityData.code || municipalityData.name.toLowerCase().replace(/\s+/g, '_'),
                name: municipalityData.name,
                regionId: municipalityData.regionId,
                countryCode: municipalityData.countryCode
            });
            return response.data;
        } catch (error) {
            console.error('Error updating municipality:', error);
            throw error;
        }
    },

    deleteMunicipality: async (municipalityId) => {
        const response = await api.delete(`/subregions/${municipalityId}`);
        return response.data;
    },

    createTown: async (townData) => {
        // Map cityType values to cityTypeId
        const cityTypeMap = {
            "гр.": "1",
            "с.": "2",
            "район": "3",
            "обл.": "4",
            "ж.к.": "5",
            "к.к.": "6",
            "ул.": "7",
            "ман.": "8",
            "бул.": "9",
            "пл.": "10"
        };

        const formattedData = {
            name: townData.name,
            ekatte: townData.ekatte,
            postal: townData.postal,
            cityTypeId: cityTypeMap[townData.cityType] || "1",
            regionId: townData.regionId,
            countryId: townData.countryId,
            cSubRegionId: townData.municipalityId
        };

        const response = await api.post('/cities', formattedData);
        return response.data;
    },

    getTownById: async (townId) => {
        try {
            const response = await api.get(`/cities/${townId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching town:', error);
            throw error;
        }
    },

    updateTown: async (townId, townData) => {
        try {
            const formattedData = {
                id: townId,
                name: townData.name,
                ekatte: townData.ekatte,
                postal: townData.postal,
                cityTypeId: townData.cityTypeId,
                regionId: townData.regionId,
                cSubRegionId: townData.municipalityId,
                transliteration: townData.transliteration,
                countryId: townData.countryId
            };

            const response = await api.put(`/cities/${townId}`, formattedData);
            return response.data;
        } catch (error) {
            console.error('Error updating town:', error);
            console.error('Error status:', error.response?.status);
            console.error('Error data:', error.response?.data);
            throw error;
        }
    },

    deleteTown: async (townId) => {
        try {
            const response = await api.delete(`/cities/${townId}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting town:', error);
            throw error;
        }
    },

    getRegion: async (regionId) => {
        try {
            const response = await api.get(`/regions/${regionId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching region:', error);
            throw error;
        }
    }
};